import { MessageCircle, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CTASectionProps {
  title?: string;
  subtitle?: string;
  body?: string;
  whatsappUrl?: string;
  mapsUrl?: string;
}

const CTASection = ({
  title,
  subtitle,
  body,
  whatsappUrl = 'https://wa.me/573245044606?text=Hola!%20Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20Tyche',
  mapsUrl = 'https://maps.app.goo.gl/rzob91zuvMGXGsyo6',
}: CTASectionProps) => {

  return (
    <section id="contacto" className="py-24 lg:py-32 bg-onyx-light relative overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5" />
      
      {/* Gold accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-gold" />

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6">
            {title ?? (
              <>Descubre el aroma y brillo de <span className="text-gold-gradient">Tyche</span></>
            )}
          </h2>
          
          <p className="font-body text-lg text-muted-foreground mb-10 max-w-xl mx-auto leading-relaxed">
            {body ??
              'Visítanos en nuestra tienda o contáctanos por WhatsApp para una asesoría personalizada. Tu próxima pieza favorita te está esperando.'}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="crimson"
              size="xl"
              asChild
            >
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                <MessageCircle className="mr-2 h-5 w-5" />
                Contactar por WhatsApp
              </a>
            </Button>
            <Button
              variant="goldOutline"
              size="xl"
              asChild
            >
              <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
                <MapPin className="mr-2 h-5 w-5" />
                Ver ubicación en Maps
              </a>
            </Button>
          </div>

          {/* Trust badge */}
          <div className="mt-12 pt-8 border-t border-border">
            <p className="font-body text-sm text-muted-foreground">
              <span className="text-primary">★</span> Atención personalizada todos los días, 08:00 - 20:00 hs
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
